import { ReactNode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Providers from 'Providers';
import { makeStaticStyles } from '@fluentui/react-components';
import CartWorkflowWizard from './pages/Cart/CartWorkflowWizard/CartWorkflowWizard';
import { root } from '@fluentui-contrib/react-shadow';
import useInternetOrderCartWorkflow from 'pages/Cart/CartWorkflowWizard/InternetOrderCartWorkflowWizardHook';
import useCartWorkflow from 'pages/Cart/CartWorkflowWizard/CartWorkflowWizardHook';
import ProcessPayment from 'pages/ProcessPayment/ProcessPayment';

const useStaticStyles = makeStaticStyles({
    '@font-face': {
        fontFamily: 'Rubik',
        src: `url(${process.env.PUBLIC_URL}/rubik.woff2) format('woff2')`
    }
});

// Create a style sheet containing a subset of Font Awesome CSS rules that are defined in the document <head>
// but are ignored because of our Shadow DOM. This subset apppears to be enough to fix our sizing bug with the
// tag icon.
//
// An alternative would be to write a function which iterates through all the stylesheets in the document
// and copy any CSS rules containing the phrase "svg-inline--fa" into a CSSStyleSheet object, then pass
// to the shadow root.
const faStyleSheetHack = new CSSStyleSheet();
faStyleSheetHack.insertRule(`
    svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
        overflow: visible;
        box-sizing: content-box;
    }
`);
faStyleSheetHack.insertRule(`
    .svg-inline--fa {
        display: var(--fa-display, inline-block);
        height: 1em;
        overflow: visible;
        vertical-align: -0.125em;
    }
`);
const externalStyleSheets = [faStyleSheetHack];

function App(props: { children: ReactNode }) {
    useStaticStyles();
    return <root.div styleSheets={externalStyleSheets}>{props.children}</root.div>;
}

const reactRoot = ReactDOM.createRoot(document.getElementById('react-app-root') as HTMLElement);

reactRoot.render(
    <Providers>
        <BrowserRouter>
            <App>
                <Routes>
                    <Route
                        path='cart'
                        element={
                            <CartWorkflowWizard
                                steps={useCartWorkflow()}
                                title='Secured Checkout'
                            />
                        }
                    />
                    <Route
                        path='internet-ordering'
                        element={
                            <CartWorkflowWizard
                                steps={useInternetOrderCartWorkflow()}
                                title='Internet Order Inquiry'
                            />
                        }
                    />
                    <Route path='payment' element={<ProcessPayment />} />
                </Routes>
            </App>
        </BrowserRouter>
    </Providers>
);
